import { render, staticRenderFns } from "./PlaceholderSelector.vue?vue&type=template&id=6372112a"
import script from "./PlaceholderSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlaceholderSelector.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports